import React from 'react';
import PropTypes from 'prop-types';
import useLanguage from '../../../../hooks/useLanguage';
import PhoneInput from 'react-phone-input-2';

const PhonesInput = ({ phone, setPhone }) => {
  const langToggle = useLanguage;
  return (
    <div className="free__form-input__wrapper is-phone form-animate">
      <label className="free__form-label">
        {langToggle('Телефон:', 'Телефон:')}
      </label>
      <PhoneInput
        country={'ua'}
        className="phone"
        value={phone}
        onChange={setPhone}
        required
      />
    </div>
  );
};

PhonesInput.propTypes = {
  phone: PropTypes.string,
  setPhone: PropTypes.func,
};

export default PhonesInput;
